import { createStyles, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() =>
  createStyles({
    root: { lineHeight: '2rem !important' },
    logoLinkWrapper: {
      position: 'absolute',
      bottom: 0,
      height: '100%',
      '& > a': { display: 'flex', height: '100%' },
      '& > a > div': { backgroundSize: '100%' }
    },
    innerNavWrapper: {
      '& > div:nth-child(1)': { maxHeight: '2.5rem' },
      '& > div:nth-child(1) > div': { maxHeight: '2.5rem' },
      '& > div:nth-child(1) > div div': { maxHeight: '2.5rem' },
      '& > div:nth-child(1) > div div > a': {
        display: 'inline-block',
        height: '100%',
        width: '100%',
        textAlign: 'center',
        '&:hover': {
          backgroundColor: 'inherit',
          textShadow: '0px 0px 1px #1F1F1F',
          borderTopLeftRadius: 'unset',
          borderBottomLeftRadius: 'unset'
        }
      },
      '& > div:nth-child(1) > div div > div ': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        textAlign: 'center'
      }
    },
    navEntrieWrapper: {
      margin: '0 auto',
      '& > div  ': {
        height: '4rem',
        alignItems: 'center',
        '& div > button ': {
          border: 'none !important'
        }
      }
    },
    linkContainer: {
      display: 'flex',
      flexWrap: 'nowrap',
      fontSize: '0.8rem',
      margin: '0.3rem 1rem',
      fontWeight: 600
    },
    linkItem: {
      margin: '0 0.5rem',
      '& > a': {
        color: 'black',
        textDecoration: 'none',
        '&:hover': {
          color: 'black',
          textDecoration: 'none'
        }
      }
    },
    borderlessItem: {
      fontWeight: 400
    },
    shareVariation: {
      display: 'inline-block',
      fontSize: '0.8rem',
      '& > p': {
        margin: '0 0.5rem',
        display: 'inline-block'
      },
      '& > img': {
        marginRight: '1.25rem'
      }
    },
    button: {
      borderRadius: '10px',
      '& > span > a': {
        textTransform: 'capitalize'
      }
    }
  })
)
